import { Component, Input } from "@angular/core";

@Component({
    selector: "upsell-wait",
    templateUrl: "upsell-wait.html",
    styleUrls: ['upsell-wait.scss'],
    standalone: false
})

export class UpsellWaitComponent {
  @Input() iconWait: string = 'https://cdn.lonewolfranchpets.com/images/chuck-norris.png';
  @Input() iconText: string = 'WAIT!';
  @Input() isFull: boolean = false;
  @Input() title: string = '';
  @Input() description: string = '';

  constructor() {}
}
